import { Links } from '@/utils/constants';

export interface ICardType {
  title: string;
  price?: number;
  description?: string;
  buttonText: string;
  buttonLink?: Links;
  includes: string;
  features: string[];
}

export const APP_PLANS: ICardType[] = [
  {
    title: 'Free',
    price: 0,
    description: 'Start building and testing your application today!',
    buttonText: 'Get a demo',
    includes: 'Includes:',
    features: [
      'App templates',
      'Visual app builder',
      'In-browser app previews',
      'Content management system',
      'Screenshots editor',
    ],
  },
  {
    title: 'Professional',
    price: 99,
    description: 'Everything you need to build and deploy your apps',
    buttonText: 'Get a demo',
    includes: 'Everything in Free, plus:',
    features: [
      'Code download & Github integration',
      'Embedded CI/CD pipelines',
      'App Store & Google Play integrations',
      'App landing page',
      'Terms and Policies generator',
    ],
  },
  {
    title: 'Custom',
    description: "We'll create a custom plan for you.",
    buttonText: 'Contact sales',
    includes: 'Everything in Agency, plus:',
    features: [
      'Dedicated account manager',
      'Priority email support',
      'Cloud project ownership transfer',
      'White-label services',
    ],
  },
];

export const TEAM_PLANS: ICardType[] = [
  {
    title: 'Team Basic',
    price: 20,
    buttonText: 'Add editors',
    includes: 'Includes:',
    features: [
      'Team workspace',
      'Collaborate on apps',
      'Billing permissions',
      'Publishing permissions',
    ],
  },
];

export const BUSINESS_PLANS: ICardType[] = [
  {
    title: 'Custom Development',
    description: 'Need a hand with development?',
    buttonText: 'Learn more',
    buttonLink: Links.CONCIERGE,
    includes: 'Includes:',
    features: [
      'UX/UI Design',
      'Mobile Development',
      'Web Development',
      'Custom integrations',
      'Custom features',
      'Legacy apps migration',
    ],
  },
  {
    title: 'Build Partner',
    description: 'Become a certified partner',
    buttonText: 'Contact sales',
    includes: 'Includes:',
    features: [
      'Listing in Partners directory & more',
      'Priority access to new features',
      'Dedicated account manager',
    ],
  },
];

export const FEATURES = [
  {
    question: 'How can I white label a CodePlatform project?',
    answer:
      "You can remove CodePlatform's logo on any paid plan if you wish to do so. If you want to white label a CodePlatform service (e.g. seamless integration with your existing platform), just contact us here.",
    linkReg: /(here)/g,
    links: [Links.TALK],
  },
  {
    question: 'Can you help me with development?',
    answer: 'We would be happy to help with your next project. Learn More.',
    linkReg: /(Learn More)/g,
    links: [Links.CONCIERGE],
  },
  {
    question: "What if I haven't found a feature that's vital for me?",
    answer:
      "Reach out to our experts and we'll discuss a solution. There's a chance it's already in the works.",
    linkReg: /(Reach out to our experts)/g,
    links: [Links.TALK],
  },
  {
    question: 'What is a Build Partner?',
    answer:
      "It's a proven agency or expert who accelerates development with the use of CodePlatform. Contact us to learn more.",
    linkReg: /(Contact us to learn more)/g,
    links: [Links.TALK],
  },
  {
    question: 'How do I cancel my subscription?',
    answer:
      "You're able to cancel your subscription on your Account Settings page. Click your avatar and select 'Account Settings' to get to the page. Otherwise, please submit a support request at support@codeplatform.com and our team will assist you.",
    linkReg: /(support@codeplatform.com)/g,
    links: ['mailto: support@codeplatform.com'],
  },
  {
    question: 'What happens when I cancel my subscription?',
    answer:
      "You will stop receiving access to updates and Cloud services provided under subscription. But no worries, the progress you've made is saved and the source code of your project still belongs to you. You can renew your subscription to regain access to the services when needed.",
  },
  {
    question:
      "What is your refund policy in case CodePlatform isn't right for me? ",
    answer:
      'We do not offer refunds after you connect to GitHub or download the source code. If you wish to test-drive our services and evaluate the quality, the Free plan is a great option for you. Additionally, you may choose the membership with a monthly billing interval to experience all features.',
  },
  {
    question:
      'Can I change my email address after I have subscribed to CodePlaftorm?',
    answer:
      'Yes, changing your email address does not affect the membership. Your account will remain intact with the new email address. You can change your email in account settings, or by contacting us at support@codeplatform.com',
    linkReg: /(support@codeplatform.com)/g,
    links: ['mailto: support@codeplatform.com'],
  },
  {
    question: 'More questions?',
    answer: 'Feel free to contact us.',
    linkReg: /(contact us)/g,
    links: [Links.TALK],
  },
];
